export default __webpack_public_path__ + "static/media/A_wdt_c_cap_0.f08d36b4.mp3";